import { useWaveAuth } from '@/auth/WaveAuthContext';

/**
 * Sticks to the top of every page while a Wave admin is signed in as a creator.
 * Deliberately loud and in a colour the portal never otherwise uses, because the
 * failure this guards against is an admin forgetting whose account they are in.
 */
const ImpersonationBanner = () => {
    const { impersonation, logout } = useWaveAuth();

    if (impersonation === null) {
        return null;
    }

    return (
        <div
            role="status"
            className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-400 px-4 py-2 text-center text-sm font-semibold text-black"
        >
            <span>
                {`Viewing as ${impersonation.creatorName} — signed in as ${impersonation.staffEmail}. ` +
                    'This session ends within 15 minutes.'}
            </span>
            <button type="button" onClick={logout} className="underline underline-offset-2">
                End session
            </button>
        </div>
    );
};

export default ImpersonationBanner;
